import { render } from "./RequestForm.vue?vue&type=template&id=68fc336a"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__